// Generated by Claude Code
import { Type } from 'class-transformer'
import { BaseIdModel } from '#core/entities/shared/BaseModels.ts'

export type CompanyAccessRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED'

const STATUS_ORDER: Record<CompanyAccessRequestStatus, number> = { PENDING: 0, APPROVED: 1, REJECTED: 2 }

const STATUS_KEY: Record<CompanyAccessRequestStatus, string> = {
  PENDING: 'shared.fields.pending',
  APPROVED: 'usersTeams.accessRequests.status.approved',
  REJECTED: 'usersTeams.accessRequests.status.rejected',
}

const STATUS_BADGE: Record<CompanyAccessRequestStatus, string> = {
  PENDING: 'bg-warning bg-opacity-10 text-warning',
  APPROVED: 'bg-success bg-opacity-10 text-success',
  REJECTED: 'bg-danger bg-opacity-10 text-danger',
}

/** A person asking to join the current company, as listed by `GET /auth/company-access-requests/`. */
export default class CompanyAccessRequest extends BaseIdModel {
  user_id: string = ''
  email: string = ''
  first_name: string | null = null
  last_name: string | null = null
  status: CompanyAccessRequestStatus = 'PENDING'
  @Type(() => Date)
  created_at: Date | null = null
  decided_by_user_id: string | null = null
  @Type(() => Date)
  decided_at: Date | null = null

  get displayName(): string {
    return [this.first_name, this.last_name].filter(Boolean).join(' ') || this.email
  }

  get isPending(): boolean {
    return this.status === 'PENDING'
  }

  /** `settings` key of the status label. */
  get statusKey(): string {
    return STATUS_KEY[this.status]
  }

  get statusBadgeClass(): string {
    return STATUS_BADGE[this.status]
  }

  /** Pending requests first, then newest first. */
  static byPendingFirst(a: CompanyAccessRequest, b: CompanyAccessRequest): number {
    return STATUS_ORDER[a.status] - STATUS_ORDER[b.status]
      || (b.created_at?.getTime() ?? 0) - (a.created_at?.getTime() ?? 0)
  }
}
